import { useMutation } from '@apollo/client';
import {
    ModalContent,
    ModalTitle,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { css } from '@emotion/react';
import { captureException } from '@sentry/react';
import { Grid } from '@material-ui/core';
import { Body1 } from '../../blocks';
import { UPDATE_CLAIM } from '../../ClaimDetails/graphql';
import { useContext } from 'react';
import { UserContext } from '@/components/App';

const CloseClaimModal = ({ claim, open, onClose, onSave, callbacks }) => {
    const { user } = useContext(UserContext);

    const [updateClaim, { loading: saveInFlight }] = useMutation(UPDATE_CLAIM, {
        onError: (error) => {
            console.error(error);
            captureException(error);
            callbacks.setNotification({
                severity: 'error',
                message: `Failed to update claim. ${error.message}`,
            });
        },
    });

    const closeClaim = () => {
        updateClaim({
            variables: {
                claim_id: claim.claim_id,
                update: { claim_status: 'CLOSED', completed_by: user.user_id },
            },
        }).then(() => {
            onSave();
        });
    };

    return (
        <ResponsiveSidebarDialog open={open} onClose={onClose}>
            <ModalTitle title={'Close Claim'} onClose={onClose} />
            <ModalContent
                css={css`
                    width: 400px;
                `}
            >
                <Grid container direction="column" css={css``}>
                    <Grid item>
                        <Body1>Are you sure you want to close this claim?</Body1>
                    </Grid>
                    <Grid item>
                        <Body1>The claim will be permanently archived.</Body1>
                    </Grid>
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid item>
                    <SecondaryButton disabled={saveInFlight} onClick={onClose}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item>
                    <PrimaryButton red disabled={saveInFlight} onClick={closeClaim}>
                        Yes
                    </PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default CloseClaimModal;
